import { gsap } from 'gsap'

import Footer from '../../../Footer'
import Header from '../../../Header'
import ProgressRing from '../../../ProgressRing'

import useLoading from '../../../../config/hooks/useLoading'
import { GUIProps } from '../../../../config/types'

import {
  // Prompt,
  Back,
  Camera,
  ReverseCamera,
  Snapshot,
  Loader,
  Logo,
  Hand,
  // ResetButton,
  ResetExperience,
  SharkOutlineContainer,
} from './styles'

import handSrc from '../../../../assets/hand_prompt.png'
// import promptSrc from '../../../../assets/Prompt.png'
import loadingSrc from '../../../../assets/loading.png'
import phoneSrc from '../../../../assets/Phone.png'
import SharkOutlineSrc from '../../../../assets/SharkOutline.png'
import cameraBtnSrc from '../../../../assets/CameraButton.png'
import snapshotSrc from '../../../../assets/snapshot_camera_button.png'
import reverseSrc from '../../../../assets/reverse.png'
import resetSrc from '../../../../assets/reset.png'
import backBtnSrc from '../../../../assets/BackButton.png'

import Analytics from '../../../../config/analytics'

const GUI = ({ step, set, experience }: GUIProps) => {
  const { progress } = useLoading(step, experience)

  const isStep0 = step === 0
  const isStep1 = step === 1

  experience.current?.eventEmitter.on('sharkSeenEvent', (value: boolean) => {
    if (!value) {
      gsap.to('#reset-btn', {
        opacity: 1,
        display: 'block',
        duration: 0.2,
      })
    } else {
      const resetBtn = document.getElementById('reset-btn') as HTMLButtonElement

      resetBtn.style.display = 'none'
      resetBtn.style.opacity = '0'
    }
  })

  /**
   * Navigation
   */
  const handleNextStep = () => set(step + 1)

  const handlePreviousStep = () => {
    Analytics.event.back_button_click()
    set(step - 1)
  }

  /**
   * Features
   */
  const handleSnapshot = () => {
    Analytics.event.take_photo_click()
    experience.current?.world.snapshot.capture()
  }

  const handleReverseCamera = () => {
    Analytics.event.camera_reverse_click()
    experience.current?.camera.reverse()
  }

  const handleReset = () => {
    Analytics.event.reset_button_click()

    const handPrompt = document.getElementById('hand-prompt')
    const cameraBtn = document.getElementById('camera-btn')
    const phonePrompt = document.getElementById('outline-container')
    const resetBtn = document.getElementById('reset-btn')

    if (
      resetBtn?.style &&
      phonePrompt?.style &&
      handPrompt?.style &&
      cameraBtn?.style
    ) {
      resetBtn.style.display = 'none'
      resetBtn.style.opacity = '0'

      cameraBtn.style.display = 'none'
      cameraBtn.style.opacity = '0'

      handPrompt.style.display = 'none'
      handPrompt.style.opacity = '0'

      phonePrompt.style.display = 'flex'
      phonePrompt.style.opacity = '1'
    }

    experience.current?.world.shark.reset()
  }

  return (
    <>
      {isStep0 && (
        <>
          <Header />
          <Footer />

          <ResetExperience id="reset-btn" onClick={handleReset}>
            <img
              id="reverse-btn"
              alt="reverse"
              className="noselectimg"
              src={resetSrc}
              loading="eager"
            />
          </ResetExperience>
        </>
      )}

      <Loader id="splash-screen" className="loader">
        <Logo src={loadingSrc} alt="loading" loading="eager" />
        <ProgressRing radius={95} stroke={4} {...{ progress }} />
      </Loader>

      {isStep1 && (
        <>
          <Back
            id="back-btn"
            src={backBtnSrc}
            alt="back"
            onTouchStart={handlePreviousStep}
          />

          <ReverseCamera onClick={handleReverseCamera}>
            <img
              id="reverse-btn"
              alt="reverse"
              className="noselectimg"
              src={reverseSrc}
              loading="eager"
            />
          </ReverseCamera>

          <Snapshot onClick={handleSnapshot}>
            <div id="snapshot-container">
              <img
                id="snapshot-btn"
                alt="snapshot"
                loading="eager"
                className="noselectimg"
                draggable="false"
                src={snapshotSrc}
              />
            </div>
          </Snapshot>
        </>
      )}

      <Hand>
        <img
          id="hand-prompt"
          alt="hand"
          loading="eager"
          className="noselectimg"
          draggable="false"
          src={handSrc}
        />
      </Hand>

      <Camera
        id="camera-btn"
        src={cameraBtnSrc}
        alt="camera"
        onTouchStart={handleNextStep}
      />

      <SharkOutlineContainer id="outline-container">
        <img
          id="target"
          alt="shark outline"
          src={SharkOutlineSrc}
          loading="eager"
        />
        <img
          id="phone"
          draggable="false"
          alt="phone"
          src={phoneSrc}
          loading="eager"
        />
      </SharkOutlineContainer>
    </>
  )
}

export default GUI
